import type { FormattedSegment, FormattedStop} from './google-maps';
import {formatAddress, stopIsValid} from './google-maps'
import objectHash from 'object-hash'

// TODO: cache in local storage?
const DIRECTIONS_CACHE = new Map<string, Promise<google.maps.DirectionsResult>>()

// Costs half a cent per query; https://developers.google.com/maps/billing-and-pricing/pricing#directions
export async function getMapDirectionsForSegment(seg: FormattedSegment): Promise<google.maps.DirectionsResult> {
    if(!seg) {
        throw new Error("Segment undefined")
    }
    return getMapDirections(seg.stops)
}

export async function getMapDirections(stops: FormattedStop[]): Promise<google.maps.DirectionsResult> {
    if(!stops) {
        throw new Error("Stops undefined")
    }
    if(stops.length < 2) {
        throw new Error("Not enough stops")
    }
    if(stops.some(s => !stopIsValid(s))) {
        throw new Error("Invalid stop")
    }
    const waypoints = stops.map(formatAddress)
    if(waypoints.some(x => !x)) {
        throw new Error("Empty address")
    }
    if(!window.google?.maps?.DirectionsService) {
        throw new Error("Google Maps API not loaded")
    }

    const origin = waypoints.shift()!
    const destination = waypoints.pop()!

    const directionsRequest: google.maps.DirectionsRequest = {
        origin: origin,
        waypoints: waypoints.map(stop => ({location: stop})),
        destination: destination,
        travelMode: google.maps.TravelMode.DRIVING,
    }

    const cacheKey = objectHash(directionsRequest)

    if(DIRECTIONS_CACHE.has(cacheKey)) {
        return await DIRECTIONS_CACHE.get(cacheKey)!
    }

    const service = new google.maps.DirectionsService()

    const promise = new Promise<google.maps.DirectionsResult>((resolve, reject) => {
        service.route(directionsRequest, (res, status) => {
            if(status !== google.maps.DirectionsStatus.OK) {
                return reject(new Error(status))
            }
            return resolve(res!)
        })
    })

    DIRECTIONS_CACHE.set(cacheKey, promise)
    return promise
}
